// extracted by mini-css-extract-plugin
export var content = "_9a-3";
export var list = "_9a-4";
export var settingsContent = "_9a-7";
export var settingsPanel = "_9a-8";
export var state = "_9a-6";
export var triggerBadge = "_9a-2";
export var triggerButton = "_9a-1";
export var triggerShell = "_9a-0";
export var unreadDot = "_9a-5";